var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"multi-steps"},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.name,class:{'is-active': _vm.isActive == index},attrs:{"aria-current":_vm.isActive == index ? 'step' : false}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }